import React, {useEffect, useRef} from 'react';
import AceEditor from 'react-ace';

import SQLEditor from 'insights/warehouse/sql-editor/SQLEditor';
import {useDebounce} from 'ui-library/hooks/useDebounce';

export interface WarehouseDiagramSQLEditorProps {
  modalSQLQuery: string;
  onModalSQLQueryChange: (newSQLQuery: string) => void;
  sidebarWidth: number;
}

export default function WarehouseDiagramSQLEditor(props: WarehouseDiagramSQLEditorProps): JSX.Element {
  const editorRef = useRef<AceEditor>(null);
  // Debounce sidebar width changes to improve resize performance.
  const debouncedSidebarWidth = useDebounce<number>(props.sidebarWidth, 100);

  useEffect(() => {
    // @ts-expect-error The AceEditor type does not come with the "editor" property, but it is documented
    // to exist. See https://github.com/securingsincity/react-ace/blob/master/docs/FAQ.md.
    editorRef.current!.editor.resize();
  }, [debouncedSidebarWidth]);

  return (
    <SQLEditor
      width="100%"
      height="100%"
      showGutter={false}
      onQueryChange={props.onModalSQLQueryChange}
      query={props.modalSQLQuery}
      editorRef={editorRef}
    />
  );
}
